function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.49 9.453l.055.02a1.506 1.506 0 01.183.086l.022.013.026.015c.028.016.055.034.082.053l-.108-.068a1.517 1.517 0 01.536.525l.013.024 6.5 11.258.023.04c.01.02.021.04.03.061l-.053-.1a1.516 1.516 0 01.2.715l.001.034v.013c0 .03-.001.06-.003.089l.003-.102a1.517 1.517 0 01-.066.44l-.018.056a1.156 1.156 0 01-.08.188 1.517 1.517 0 01-.572.607l-.014.008-.02.012a1.495 1.495 0 01-.088.045l.108-.057a1.517 1.517 0 01-.716.201H10.466c-.028 0-.057-.002-.086-.004l.12.004a1.516 1.516 0 01-.728-.188l-.022-.013-.015-.008a1.501 1.501 0 01-.074-.047l.089.055a1.516 1.516 0 01-.58-.603 1.328 1.328 0 01-.104-.255 1.174 1.174 0 01-.022-.078l-.012-.054a1.229 1.229 0 01-.027-.191A1.463 1.463 0 019 22.142v-.036c0-.034.002-.069.005-.103L9 22.129a1.517 1.517 0 01.187-.726l.014-.024 6.5-11.258.013-.024.05-.077-.063.1a1.515 1.515 0 01.526-.535l.023-.013.017-.01.066-.035-.083.045a1.516 1.516 0 01.26-.12l.037-.011a1.51 1.51 0 01.124-.034l.023-.005c.039-.008.078-.015.116-.02h.005c.037-.005.079-.008.12-.01h.118a1.501 1.501 0 01.127.01l.01.001c.04.005.077.01.115.019l.024.005c.029.006.057.014.085.022l.04.012.036.012zm3.412 11.176L17 13.87l-3.902 6.758h7.804z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgBig = function SvgBig(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 34,
      height: 34
    }, props), _ref)
  );
};

export default SvgBig;